import React, { useState } from 'react'
import Modal from '@bt-react/components/Modal'
import Icon, { IconType, colour } from '@bt-react/components/Icon'
import Countdown from '@bt-react/components/Countdown'
import Button from '@bt-react/components/Button'
import componentStyles from './PreviewModal.module.scss'
import SystemPreview from '../SystemPreview'
import useIsTalkLive from '../../lib/useIsTalkLive'
import { PreviewModalProps } from './types'
import audit from '../../lib/audit/audit'
import browser from '@bt-react/libs/browser'
import SystemCheck from '../SystemCheck'

const PreviewModal: React.FC<PreviewModalProps> = props => {

  const isLive = useIsTalkLive(props.date || '')
  const [ isPresenterLoading, setIsPresenterLoading ] = useState(false)

  const isChrome = browser.isChrome()


  if (!props.date) return null

  const audioSourceButton: JSX.Element | undefined = props.audioSource === 'telephone'
    ? <Button dataBdd="microphone-settings-button"
              color={IconType.colour.link}
              onClick={props.onPhoneClick}>
        <Icon
          name={IconType.iconName.microphone}
          className={componentStyles['switch-to-telephone-icon']}
        />
        Switch to computer audio
      </Button>
    : undefined

  return <Modal
    concise={true}
    isOpen={true}
    hideBorder={true}
  >
    <Modal.Header
      className={componentStyles[`Header`]}
      dataBdd='dialog-access-header'
      hideBorder={true}
    >
      <SystemCheck className={componentStyles['quality-checker']} />
      {
        isLive
          ? <span data-bdd='dialog-access-header-message' className={componentStyles['heading-text-400']} >This talk is currently live</span>
          : <Countdown
            date={props.date}
            color='black'
            countdownText='Live in'
            className={componentStyles[`countdown-heading-text`]}
          />
      }
    </Modal.Header>
    <Modal.Body className={componentStyles[`Body`]} dataBdd={`dialog-access-body`}>
      <div>
        <SystemPreview />
        <div>
          {
            props.isDialInEnabled && audioSourceButton
          }
        </div>
      </div>
      {isChrome && <Button
          onClick={props.onVirtualBackgroundsClick}
          dataBdd='virtual-backgrounds'
          color={IconType.colour.link}
          >
          <Icon
          name={IconType.iconName.imagePolaroid}
          colour={IconType.colour.green}
          className={componentStyles['virtual-background-icon']}
        /> Virtual backgrounds</Button>}
      <Button
        color={IconType.colour.primary}
        text='Enter presenter screen'
        dataBdd='dialog-button-presenter'
        onClick={() => {
          audit.addEntry('PresenterService', 'EnterPresenterScreenClicked', JSON.stringify({
            localTimestamp: Date.now().toString(),
            cookies: document.cookie,
            browser: {
              vendor: navigator.vendor,
              userAgent: navigator.userAgent
            },
            isMuted: props.isMuted,
            isHidden: props.isHidden,
            isDialInConnected: props.isDialInConnected,
            background: props.background
          }))
          setIsPresenterLoading(true)
          if (props.onEnterClick) props.onEnterClick()

        }}
        className={componentStyles[`Button`]}
        loading={isPresenterLoading}
        block={true}
        disabled={props.isButtonDisabled || false}
      />
      <div>
        Experiencing difficulties?&nbsp;
        <a
          data-bdd='system-test-link'
          className={componentStyles['system-test-link']}
          href='/talks-presenter-systemtest'
          target='_blank'
        >
          Test your system
        </a>
      </div>
    </Modal.Body>
    <Modal.Footer className={componentStyles[`Footer`]} />
  </Modal>

}

export default PreviewModal
